import { takeLatest } from "redux-saga/effects";
import { getCatalogsAction } from "./catalogActions";
import { getCatalogSaga } from "./sagas/getCatalogSaga";

export function* catalogsSaga() {
  yield takeLatest(getCatalogsAction.type, getCatalogSaga);
}
